'use client'

interface Props {
    articlesCount: number;
}

export const CarouselNavigation = ({ articlesCount }: Props) => {
    const scrollToSlide = (index: number) => {
        const carousel = document.getElementById('articles-carousel');
        if (carousel) {
            carousel.scrollTo({ left: index * carousel.clientWidth, behavior: 'smooth' });
        }
    };

    const scrollPrevious = () => {
        const carousel = document.getElementById('articles-carousel');
        if (carousel) {
            carousel.scrollBy({ left: -carousel.clientWidth, behavior: 'smooth' });
        }
    };

    const scrollNext = () => {
        const carousel = document.getElementById('articles-carousel');
        if (carousel) {
            carousel.scrollBy({ left: carousel.clientWidth, behavior: 'smooth' });
        }
    };

    return (
        <>
            {/* Navigation arrows */}
            <button
                className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/30 hover:bg-black/50 text-white rounded-full flex items-center justify-center transition-all backdrop-blur-sm"
                onClick={scrollPrevious}
                aria-label="Article précédent"
            >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
            </button>

            <button
                className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/30 hover:bg-black/50 text-white rounded-full flex items-center justify-center transition-all backdrop-blur-sm"
                onClick={scrollNext}
                aria-label="Article suivant"
            >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
            </button>

            {/* Dots indicator */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
                {Array.from({ length: articlesCount }, (_, index) => (
                    <button
                        key={index}
                        className="w-3 h-3 bg-white/50 hover:bg-white rounded-full transition-all duration-200"
                        onClick={() => scrollToSlide(index)}
                        aria-label={`Aller à l'article ${index + 1}`}
                    />
                ))}
            </div>
        </>
    );
};
